import { MyCohortProgressEnum } from '@platform/client/schemas';
import type { TimelineStage } from './CohortTimeline';

/**
 * The cohort steps in the order a professional moves through them. Kept explicit rather than
 * derived from `MyCohortProgressEnum` to keep order. */
const PROGRESS_ORDER = [
  'kickoff',
  'matching',
  'planning',
  'action',
  'reflect',
  'wrap_up',
] as const satisfies readonly MyCohortProgressEnum[];

/** Places a single timeline step relative to the step the user is currently on. */
export const getProgressItemStage = (
  userProgress: MyCohortProgressEnum,
  step: MyCohortProgressEnum,
): TimelineStage => {
  const stepIndex = PROGRESS_ORDER.indexOf(step);
  const userProgressIndex = PROGRESS_ORDER.indexOf(userProgress);
  if (userProgressIndex === -1 || stepIndex === -1) {
    throw new Error(`Invalid user progress or step: ${userProgress}, ${step}`);
  }
  if (stepIndex < userProgressIndex) {
    return 'completed';
  }
  return stepIndex === userProgressIndex ? 'in-progress' : 'not-started';
};
